import _ from 'underscore'

import service from '../service/pay'
import PAYCONSTANT from '../constant/pay'

export default {
  getPayStatus ({ commit }, query) {
    return new Promise((resolve, reject) => {
      return service.getPayStatus(query).then(data => {
        commit(PAYCONSTANT.PAY_GET_STATUS_SUCCESS, data)
        resolve(data)
        return data
      }, e => {
        commit(PAYCONSTANT.PAY_GET_STATUS_ERROR, e)
        reject(e)
      })
    })
  },
  getPayOrderAct ({commit}, query) {
    return new Promise((resolve, reject) => {
      return service.getPayOrderAct(query).then(data => {
        resolve(data)
        return data
      }, e => {
        reject(e)
      })
    })
  }
}
